import { UseFormReturn } from "react-hook-form";

import Form from "../base/Form/Form";
import { Button } from "../base/Button";
import { FormErrors } from "../base/Form/FormErrors";
import { FormTextField } from "../base/Form/FormTextField";
import Modal, { ModalControlProps } from "../../layouts/Modal";
import useShopifyStoreMutations from "../../data/ShopifyStore/useShopifyStoreMutations";
import { IShopifyStore } from "../../models/ShopifyStore/ShopifyStore";
import { CreateUpdateShopifyStoreFormFields } from "../../models/ShopifyStore/CreateUpdateShopifyStore";

interface CreateUpdateShopifyStoreModalProps extends ModalControlProps {
  customerId: string;
  store?: IShopifyStore;
}

export function CreateUpdateShopifyStoreModal({
  open,
  setOpen,
  customerId,
  store,
}: CreateUpdateShopifyStoreModalProps) {
  const { create, update } = useShopifyStoreMutations(customerId);
  const normalisePayload = (
    data: CreateUpdateShopifyStoreFormFields
  ): CreateUpdateShopifyStoreFormFields => ({
    domain: data.domain ?? "",
    appClientId: data.appClientId ?? "",
    appClientSecret: data.appClientSecret ?? "",
    publicationId: data.publicationId ?? "",
    state: data.state ?? "",
    accessToken: data.accessToken ?? "",
  });

  const createStore = (data: CreateUpdateShopifyStoreFormFields) => {
    create.mutate(normalisePayload(data), {
      onSuccess: () => {
        setOpen(false);
      },
    });
  };

  const updateStore = (data: CreateUpdateShopifyStoreFormFields) => {
    update.mutate(
      {
        ...normalisePayload(data),
        id: store?.id,
      },
      {
        onSuccess: () => {
          setOpen(false);
        },
      }
    );
  };

  return (
    <Modal open={open} setOpen={setOpen} width="!w-2/3">
      <div>
        <div className="border-b">
          <h2 className="text-lg font-stick font-medium leading-6 mb-4 text-gray-900">
            {store ? "Edit" : "Add"} Shopify Store
          </h2>
        </div>
        <Form<CreateUpdateShopifyStoreFormFields>
          defaultValues={store ? store : {}}
          onSubmit={store ? updateStore : createStore}
          className="pt-4 grid grid-cols-1 gap-y-4 md:grid-cols-2 md:gap-4"
        >
          {({ register }: UseFormReturn<CreateUpdateShopifyStoreFormFields>) => (
            <>
              <div className="-m-4 md:col-span-2">
                <FormErrors />
              </div>
              <div className="md:col-span-2">
                <FormTextField {...register("domain")} label="Store Domain" />
              </div>
              <FormTextField {...register("appClientId")} label="App Client Id" />
              <FormTextField
                {...register("appClientSecret")}
                label="App Client Secret"
              />
              <FormTextField {...register("publicationId")} label="Publication Id" />
              <FormTextField {...register("state")} label="State" />
              <div className="md:col-span-2">
                <FormTextField {...register("accessToken")} label="Access Token" />
              </div>
              <Button type="submit">Save</Button>
              <Button type="reset" variant="outlined">
                Reset
              </Button>
            </>
          )}
        </Form>
      </div>
    </Modal>
  );
}
